let postsPerPage,
    categories,
    authors,
    postType,
    orderby,
    paged = 1;

const api = (filters)  =>{
    const data = {
        // eslint-disable-next-line no-undef
        nonce: posts_list_object.nonce,
        action: 'get_posts_card_template',
        ...filters
    }

    return jQuery.ajax({
      // eslint-disable-next-line no-undef
      url: posts_list_object.ajax_url,
      type: 'GET',
      data,
    });
}

function events(container) {
    const btnLoadMore = container.querySelector('.wp-block-buttons.load-more .wp-element-button');

    // eslint-disable-next-line no-undef
    postsPerPage = posts_list_object?.posts_per_page;

    // eslint-disable-next-line no-undef
    categories = posts_list_object?.categories;

    // eslint-disable-next-line no-undef
    postType = posts_list_object?.post_type;

    // eslint-disable-next-line no-undef
    authors = posts_list_object?.authors;
    
    // eslint-disable-next-line no-undef
    orderby = posts_list_object?.orderby;

    btnLoadMore.addEventListener('click', () => loadMorePost(container)) 
}

function loadMorePost(container) {
    const postListContainer = container.querySelector('.block-post-list__container');
    const btnLoadMore = container.parentNode.querySelector('.load-more button');

    btnLoadMore.setAttribute('disabled', true);

    loaderElements(postListContainer, postsPerPage ? postsPerPage : 3);

    paged++;

    const filters = {
        post_type: postType,
        posts_per_page: postsPerPage,
        paged
    }

    if(categories) filters.categories = categories;
    if(authors) filters.authors = authors;

    if(orderby) {
        const cards = postListContainer.querySelectorAll('.card');
        const postIds = [];

        filters.orderby = 'rand';
        filters.post__not_in = [];
        delete filters.paged;

        cards.forEach(card => {
            const id = card.dataset.id;

            if(id)
                postIds.push(id);
        });

        if(postIds.length)
            filters.post__not_in = postIds;

    }

    api(filters).done((response) => loadResponseCardPost(postListContainer, response));
}

const loaderElements = (container, count) => {

    const card = jQuery(
        `<div class="card skeleton--container">
            <div class="card-image skeleton">
            </div><div class="card-body">
                <div class="skeleton--text"></div>
                <div class="skeleton--text" style="width: 80%;"></div>

                <div class="skeleton--text" style="margin-top: 1em"></div>
                <div class="skeleton--text"></div>
                <div class="skeleton--text" style="width: 75%;"></div>
            </div>
        </div>`
    )

    for (let i = 0; i < count; i++) {
        card.clone().appendTo(container);
    }
}

function loadResponseCardPost(container, response) {
    const skeleton = container.querySelectorAll('.card.skeleton--container');
    const btnLoadMore = container.parentNode.querySelector('.load-more button');
    jQuery(skeleton).remove();

    btnLoadMore.removeAttribute('disabled');
    if(response.includes('No result(s) found.'))
        btnLoadMore.style.display = 'none';

    const responseHTML = jQuery(response);
    jQuery(container).append(responseHTML);

    const cards = container.querySelectorAll('.card');

    const errorMessageContainer = container.parentNode.querySelector('.error-message');

    if(cards.length > 0 && errorMessageContainer) {
        errorMessageContainer.textContent = 'No more results found.';
    }

    gsap.from(responseHTML, {opacity: 0});
}

function initPostsListPagination() {
    const containers = document.querySelectorAll('.block-post-list.is-style-paginated');

    containers.forEach(container => {
        const listContainer = container.querySelector('.block-post-list__container');
        if (!listContainer) return;

        const perPage = parseInt(container.dataset.perPage, 10) || 6;
        const cards = [...listContainer.querySelectorAll('.card')];

        if (cards.length <= perPage) return;

        let currentPage = 1;
        const totalPages = Math.ceil(cards.length / perPage);

        const renderPage = () => {
            const start = (currentPage - 1) * perPage;
            const end = start + perPage;
            cards.forEach((card, i) => card.classList.toggle('is-hidden', i < start || i >= end));
            prevBtn.disabled = currentPage === 1;
            nextBtn.disabled = currentPage === totalPages;
            pageInfo.textContent = `${currentPage} / ${totalPages}`;
        };

        const pagination = document.createElement('div');
        pagination.className = 'post-list__pagination';

        const prevWrapper = document.createElement('div');
        prevWrapper.className = 'wp-block-button has-btn-secondary';
        const prevBtn = document.createElement('button');
        prevBtn.className = 'wp-block-button__link wp-element-button';
        prevBtn.textContent = 'Previous';
        prevWrapper.appendChild(prevBtn);

        const pageInfo = document.createElement('span');
        pageInfo.className = 'post-list__pagination-info';

        const nextWrapper = document.createElement('div');
        nextWrapper.className = 'wp-block-button has-btn-secondary';
        const nextBtn = document.createElement('button');
        nextBtn.className = 'wp-block-button__link wp-element-button';
        nextBtn.textContent = 'Next';
        nextWrapper.appendChild(nextBtn);

        pagination.appendChild(prevWrapper);
        pagination.appendChild(pageInfo);
        pagination.appendChild(nextWrapper);
        container.appendChild(pagination);

        prevBtn.addEventListener('click', () => {
            if (currentPage > 1) {
                currentPage--;
                renderPage();
                container.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });

        nextBtn.addEventListener('click', () => {
            if (currentPage < totalPages) {
                currentPage++;
                renderPage();
                container.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });

        renderPage();
    });
}

document.addEventListener( 'DOMContentLoaded', () => {
    const postList = document.querySelectorAll('.block-post-list');

    if(!postList.length) return;

    postList.forEach(post => {
        if (!post.classList.contains('is-style-paginated')) events(post);
    });

    initPostsListPagination();
});